import { TGetUserListResDto } from "@/api/services/main/user/dtos/get-user-list.dto";
import { CACHED_TIME, STATUS_INACTIVE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { truncateWithEllipsis } from "@/utils/string";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

export const fetchUserListPersonInChargeApi = async (): Promise<TGetUserListResDto> => {
  const rs = await clientApi.get<TGetUserListResDto>("/users/person-in-charge");
  return rs.data;
};

export const useGetUserListPersonInCharge = (selectedIds?: number | number[] | null) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.MATCH.FETCH_USER_LIST],
    queryFn: () => fetchUserListPersonInChargeApi(),
    staleTime: CACHED_TIME,
    gcTime: CACHED_TIME,
  });

  const userOptions = useMemo(() => {
    if (!data) return [];

    const normalizedIds = selectedIds != null ? (Array.isArray(selectedIds) ? selectedIds : [selectedIds]) : [];
    const selectedIdSet = new Set(normalizedIds.map((id) => Number(id)));

    return data.data
      .filter((item) => (item.activeStatus !== STATUS_INACTIVE || selectedIdSet.has(Number(item.id))) && item.fullName?.trim())
      .map((item) => ({ label: truncateWithEllipsis(item.fullName, 50), value: item.id }));
  }, [data, selectedIds]);

  const getUserOptions = useCallback(
    (currentSelectedIds?: number | number[] | null) => {
      if (!data) return [];

      const normalizedIds = currentSelectedIds != null ? (Array.isArray(currentSelectedIds) ? currentSelectedIds : [currentSelectedIds]) : [];
      const selectedIdSet = new Set(normalizedIds.map((id) => Number(id)));

      return data.data
        .filter((item) => (item.activeStatus !== STATUS_INACTIVE || selectedIdSet.has(Number(item.id))) && item.fullName?.trim())
        .map((item) => ({ label: truncateWithEllipsis(item.fullName, 50), value: item.id }));
    },
    [data],
  );

  return { data: data?.data ?? [], userOptions, getUserOptions, ...rest };
};
